import React from 'react'
import { Camera, CameraOff } from 'lucide-react'

interface PhotoToggleControlProps {
  showPhotos: boolean
  onToggle: () => void
  className?: string
}

export function PhotoToggleControl({ showPhotos, onToggle, className = '' }: PhotoToggleControlProps) {
  const isEmbed = className.includes('embed-control')
  
  return (
    <button
      onClick={onToggle}
      className={isEmbed ? className : `flex items-center justify-center p-2 text-white hover:bg-gray-700/50 transition-colors ${className}`}
      title={showPhotos ? 'Hide Photos' : 'Show Photos'}
      style={isEmbed ? { display: 'flex', alignItems: 'center', justifyContent: 'center' } : {}}
    >
      {showPhotos ? (
        <Camera className={isEmbed ? 'w-[18px] h-[18px]' : 'w-4 h-4'} />
      ) : (
        <CameraOff className={isEmbed ? 'w-[18px] h-[18px]' : 'w-4 h-4'} />
      )}
    </button>
  )
}